import { createActions, createReducer } from 'reduxsauce'

/* Initial State */
const INITIAL_STATE = {
  user: {},
  userApplications: [],
  authenticated: false,
  accessToken: null,
  error: null,
  accessType: {
    status: 'full',
    message: null
  }
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  authenticationError: ['error'],

  refreshToken: [],
  refreshTokenSuccess: ['accessToken'],

  setUser: ['user'],

  loadUserApplications: [],
  loadUserApplicationsSuccess: ['userApplications'],

  login: ['email', 'password', 'onSuccess', 'onError'],
  loginSuccess: [],

  setCompletePropertyRegistration: ['property'],
  setUserDefaultProperty: ['farmPropertyDefault'],

  forgotPassword: ['email', 'onSuccess', 'onError'],
  resetPassword: ['resetBody', 'onSuccess', 'onError'],

  redirectAccess: ['accessType'],

  logout: ['error'],

  resetAuthentication: []
})


const authenticationError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})


const refreshTokenSuccess = (state = INITIAL_STATE, { accessToken }) => ({
  ...state,
  error: INITIAL_STATE.error,
  accessToken
})

const setUser = (state = INITIAL_STATE, { user }) => ({
  ...state,
  user
})

const loadUserApplicationsSuccess = (state = INITIAL_STATE, { userApplications }) => ({
  ...state,
  userApplications
})

const login = () => ({ ...INITIAL_STATE })
const loginSuccess = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error,
  authenticated: true
})

const setCompletePropertyRegistration = (state = INITIAL_STATE) => ({
  ...state,
  user: {
    ...state.user,
    isCompleteFirstFarm: true
  }
})

const setUserDefaultProperty = (state = INITIAL_STATE, { farmPropertyDefault }) => ({
  ...state,
  user: {
    ...state.user,
    farmPropertyDefault
  }
})

const redirectAccess = (state = INITIAL_STATE, { accessType }) => ({
  ...state,
  accessType
})

const logout = (state, { error }) => ({ ...INITIAL_STATE, error })

const resetAuthentication = () => ({ ...INITIAL_STATE })

/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.AUTHENTICATION_ERROR]: authenticationError,

  [Types.REFRESH_TOKEN_SUCCESS]: refreshTokenSuccess,

  [Types.SET_USER]: setUser,

  [Types.LOAD_USER_APPLICATIONS_SUCCESS]: loadUserApplicationsSuccess,

  [Types.LOGIN]: login,
  [Types.LOGIN_SUCCESS]: loginSuccess,

  [Types.SET_COMPLETE_PROPERTY_REGISTRATION]: setCompletePropertyRegistration,
  [Types.SET_USER_DEFAULT_PROPERTY]: setUserDefaultProperty,

  [Types.REDIRECT_ACCESS]: redirectAccess,

  [Types.LOGOUT]: logout,

  [Types.RESET_AUTHENTICATION]: resetAuthentication
})

export {
  Types as AuthenticationTypes,
  Creators as AuthenticationActions
}
